import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const PreviewAdModalHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;

  .preview-stage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    max-height: 70vh;
    background: ${Colors.background};
    border-radius: 6px;
    overflow: hidden;

    img,
    video {
      max-width: 100%;
      max-height: 70vh;
      object-fit: contain;
    }

    audio {
      width: 90%;
    }

    .preview-spin {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .preview-unsupported {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      color: ${Colors.textMuted};
      padding: 32px;

      .anticon {
        font-size: 40px;
        color: ${Colors.primaryAccent};
      }
    }
  }

  .preview-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    font-size: 13px;
    color: ${Colors.coal};

    .preview-name {
      font-weight: 600;
      color: ${Colors.textStrong};
      width: 100%;
      
    }
  }
`

export default PreviewAdModalHolder
